import { ModuleUnreadIndicators } from "@jugl-web/rest-api";
import { createContext } from "react";
import { Observable } from "rxjs";

interface UnreadIndicatorsContextValue {
  moduleUnreadIndicators: ModuleUnreadIndicators | undefined;
  anotherEntityUpdateEvent$: Observable<{ updatedEntityId: string }>;
}

export const UnreadIndicatorsContext =
  createContext<UnreadIndicatorsContextValue | null>(null);
